<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'ANNOUNCEMENT|Komunikat' | translate}}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <h3>{{ data.announcement.title }}</h3>
        <div>
            <div [innerHTML]="announcementContent"></div>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal w-100">
            <div class="flex-horizontal right">
                <button iccButton (click)="close()">{{ 'INTERFACE|Zamknij' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>